import { useMutation, useQueryClient } from "@tanstack/react-query";
import { revokeDelegationInvitation } from "../../api/delegation";
import { delegationQueryKeys } from "./delegationQueryKeys";

export const useRevokeDelegationInvitation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => revokeDelegationInvitation(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: delegationQueryKeys.invitations,
      });
    },
  });
};
